
export default {
    name: 'antecedent-adulte-familiaux',
    components: {},
    props: ["consultation", "activeRole"],
    data() {
        return {
            is_loading: true,
            is_empty: false,

            save_loading: false,
            
            atcd_allergo_p: {
                v_model: {
                    'atcd_fratrie': '', 'allergie_fratrie': '', 'allergie_fratrie_mention': '',
                    'atopie_fratrie': '', 'atopie_fratrie_mention': '', 'atcd_pere': '',
                    'allergie_pere': '', 'allergier_pere_mention': '', 'atopie_pere': '',
                    'atopie_pere_mention': '', 'atcd_mere': '', 'allergie_mere': '',
                    'allergier_mere_mention': '', 'atopie_mere': '', 'atopie_mere_mention': '',
                },
            },

            fields: {
                'atcd_fratrie': '', 'allergie_fratrie': '', 'allergie_fratrie_mention': '',
                'atopie_fratrie': '', 'atopie_fratrie_mention': '', 'atcd_pere': '',
                'allergie_pere': '', 'allergier_pere_mention': '', 'atopie_pere': '',
                'atopie_pere_mention': '', 'atcd_mere': '', 'allergie_mere': '',
                'allergier_mere_mention': '', 'atopie_mere': '', 'atopie_mere_mention': '',
            },

            // fields: [
            //     'atcd_fratrie', 'allergie_fratrie', 'allergie_fratrie_mention',
            //     'atopie_fratrie', 'atopie_fratrie_mention', 'atcd_pere',
            //     'allergie_pere', 'allergier_pere_mention', 'atopie_pere',
            //     'atopie_pere_mention', 'atcd_mere', 'allergie_mere',
            //     'allergier_mere_mention', 'atopie_mere', 'atopie_mere_mention'
            // ],
        }
    },
    computed: {
        antecedent_adulte_familiaux() {
            return this.$store.getters["antecedent_adulte_familiaux"];
        },
    },
    mounted() {
        this.listeChampATCDENFfamiliaux()
    },
    methods: {
        initFields() {
            const fld_keys = Object.keys(this.fields);
            console.log("FAM: ",this.antecedent_adulte_familiaux)
            fld_keys.forEach((key) => {
                this.atcd_allergo_p.v_model[key] = this.antecedent_adulte_familiaux[key]

                this.is_loading = false
                
            });


            // var i = 0
            
            // this.fields.forEach((fld, index) => {
            //     var v = ''
            //     if (this.antecedent_adulte_familiaux.length > 0) {
            //         v = this.antecedent_adulte_familiaux[index]['field_content']
            //     }
                
            //     this.atcd_allergo_p.v_model.push({
            //         field_name: fld,
            //         value: v
            //     })
            //     i++

            //     if (i == (this.fields.length - 1)) {
            //         this.is_loading = false
            //     }
            // });
        },

        async listeChampATCDENFfamiliaux() {
            this.is_loading = true
            let filter_data = {
                patient_id: this.consultation.patient_id,
                data_type: 'antecedent_adulte_familiaux',
                est_en_cours: true
            }

            this.$store.dispatch('getPatientAntecedent', filter_data).then(() => {
                this.initFields()
            })
        },

        saveAntecedent() {
            this.save_loading = true

            let data = {
                patient_id: parseInt(this.consultation.patient_id),
                data_type: 'antecedent_adulte_familiaux',
                antecedents: this.atcd_allergo_p.v_model,
                atcd_persistent: 1      //  0 si l'antécédent doit se vider lorsqu'on termine la consultation
            }

            this.$store.dispatch('savePatientAntecedent', data).then((response) => {
                console.log(response)
                if (response > 0) {
                    this.listeChampATCDENFfamiliaux()
                }

                this.save_loading = false
            })
        }
    }
}


